var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useReducer, useRef, } from "react";
import { isEmpty } from "lodash-es";
import { useAccount, useOnAccountLogin, useOnAccountLogout, } from "../AccountProvider";
import { isSKLand } from "../helper";
import { PresetChannelOptionMap, } from "./Channels";
import { LoginChannelSelect } from "./ChannelSelect";
import { DEFAULT_ROLE_CONTEXT_STORE, RoleContext, } from "./context";
import { useShowRoleSelect } from "./hooks";
import { OptionalAccountWrapper } from "./OptionalAccountWrapper";
import { clearRoleMeta, getRoleMeta, setRoleMeta } from "./utils";
export function RoleProvider(props) {
    var _this = this;
    var sdkReady = props.sdkReady, _a = props.disableAccount, disableAccount = _a === void 0 ? false : _a, accountProviderProps = props.accountProviderProps, gameCode = props.gameCode, _b = props.disableAccountInheritRole, disableAccountInheritRole = _b === void 0 ? false : _b, _c = props.disableAccountAutoSelectRole, disableAccountAutoSelectRole = _c === void 0 ? false : _c, _d = props.disableAccountRoleSelect, disableAccountRoleSelect = _d === void 0 ? false : _d, channels = props.channels, _e = props.skipChannelSelect, skipChannelSelect = _e === void 0 ? true : _e, _f = props.customChannelSelect, customChannelSelect = _f === void 0 ? false : _f, state = props.state, fetchRoleInfo = props.fetchRoleInfo, onNoRole = props.onNoRole, onError = props.onError, site = props.site, onSelectRole = props.onSelectRole, children = props.children;
    var _g = __read(useReducer(function (store, payload) {
        if (isEmpty(payload))
            return store;
        return __assign(__assign({}, store), payload);
    }, __assign(__assign({}, DEFAULT_ROLE_CONTEXT_STORE), { loading: true })), 2), store = _g[0], dispatch = _g[1];
    var channelConfigList = useMemo(function () { return (channels ? initChannelConfig(channels) : []); }, [channels]);
    var fetchAccountRole = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, _fetchAccountRole({
                    sdkReady: sdkReady,
                    gameCode: gameCode,
                    disableAccountRoleSelect: disableAccountRoleSelect,
                    shouldGetRoleInClient: !fetchRoleInfo,
                })];
        });
    }); }, [sdkReady, gameCode, disableAccountRoleSelect, !fetchRoleInfo]);
    return (_jsx(OptionalAccountWrapper, { sdkReady: sdkReady, disabled: disableAccount, createProps: accountProviderProps, children: _jsxs(RoleContext.Provider, { value: {
                sdkReady: sdkReady,
                gameCode: gameCode,
                disableAccount: disableAccount,
                disableAccountRoleSelect: disableAccountRoleSelect,
                channelConfigList: channelConfigList,
                skipChannelSelect: skipChannelSelect,
                customChannelSelect: customChannelSelect,
                fetchRoleInfo: fetchRoleInfo,
                onSelectRole: onSelectRole,
                onNoRole: onNoRole,
                onError: onError,
                site: site,
                store: store,
                dispatch: dispatch,
                fetchAccountRole: fetchAccountRole,
            }, children: [_jsx(Setup, { state: state, disableAccountAutoSelectRole: disableAccountAutoSelectRole, disableAccountInheritRole: disableAccountInheritRole }), children, !customChannelSelect ? _jsx(LoginChannelSelect, {}) : null] }) }));
}
function Setup(_a) {
    var _this = this;
    var state = _a.state, disableAccountAutoSelectRole = _a.disableAccountAutoSelectRole, disableAccountInheritRole = _a.disableAccountInheritRole;
    var _b = useContext(RoleContext), dispatch = _b.dispatch, sdkReady = _b.sdkReady, site = _b.site, gameCode = _b.gameCode, channelConfigList = _b.channelConfigList, onSelectRole = _b.onSelectRole, onNoRole = _b.onNoRole, onError = _b.onError, fetchRoleInfo = _b.fetchRoleInfo, disableAccount = _b.disableAccount, store = _b.store, fetchAccountRole = _b.fetchAccountRole;
    var _c = useAccount(), accountReady = _c.ready, accountInfo = _c.account;
    var showRoleSelect = useShowRoleSelect();
    var accountInitiatedRef = useRef(false);
    var channelInitiatingProcessRef = useRef();
    var shouldGetRoleInClient = !fetchRoleInfo;
    var runChannelRecognizer = useCallback(function (list) { return __awaiter(_this, void 0, void 0, function () {
        var res, sdk, result, list_1, list_1_1, conf, e_1_1, u8Token, role, res2, err_1;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    res = {
                        newSelect: false,
                        roleMeta: null,
                        roleInfo: null,
                    };
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _b.sent();
                    if (!(sdk.SDK_TYPE === "HG")) return [3 /*break*/, 16];
                    result = null;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 7, 8, 9]);
                    list_1 = __values(list), list_1_1 = list_1.next();
                    _b.label = 3;
                case 3:
                    if (!!list_1_1.done) return [3 /*break*/, 6];
                    conf = list_1_1.value;
                    if (!conf.recognizer) return [3 /*break*/, 5];
                    return [4 /*yield*/, conf.recognizer({
                            sdkReady: sdkReady,
                            gameCode: gameCode,
                            state: state || {},
                            option: conf.option,
                        })];
                case 4:
                    result = _b.sent();
                    if (result) {
                        res.roleMeta = {
                            token: result.token,
                            channel: conf.channel,
                            verifier: "",
                        };
                    }
                    _b.label = 5;
                case 5:
                    list_1_1 = list_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    if (!res.roleMeta) return [3 /*break*/, 15];
                    u8Token = res.roleMeta.token;
                    _b.label = 10;
                case 10:
                    _b.trys.push([10, 14, , 15]);
                    if (!shouldGetRoleInClient) return [3 /*break*/, 12];
                    return [4 /*yield*/, sdk.U8.API.getRoleInfo(u8Token)];
                case 11:
                    role = _b.sent();
                    res.roleInfo = {
                        uid: role.uid,
                        channelMasterId: role.channelMasterId,
                        nickName: role.nickName,
                    };
                    _b.label = 12;
                case 12: return [4 /*yield*/, sdk.U8.API.grant(u8Token)];
                case 13:
                    res2 = _b.sent();
                    res.roleMeta.token = res2.token;
                    res.newSelect = true;
                    return [3 /*break*/, 15];
                case 14:
                    err_1 = _b.sent();
                    if (sdk.Utils.isSDKError(err_1) &&
                        err_1.code === "NO_ROLE") {
                        // 当通过第三方渠道登录却无游戏角色时，触发无角色回调
                        onNoRole === null || onNoRole === void 0 ? void 0 : onNoRole({ auto: false });
                    }
                    else {
                        throw err_1;
                    }
                    return [3 /*break*/, 15];
                case 15: return [3 /*break*/, 17];
                case 16:
                    if (sdk.SDK_TYPE === "GL") {
                        // 海外暂无渠道重定向登录
                        // console.warn("[channel redirect] not supported in GL_WEB_SDK.")
                    }
                    _b.label = 17;
                case 17: return [2 /*return*/, res];
            }
        });
    }); }, []);
    var runSavedChannelContinue = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var res, roleMeta;
        return __generator(this, function (_a) {
            res = {
                newSelect: false,
                roleMeta: null,
                roleInfo: null,
            };
            roleMeta = getRoleMeta({ site: site });
            if (!roleMeta)
                return [2 /*return*/, res];
            if (roleMeta.channel === "account")
                return [2 /*return*/, res];
            res.roleMeta = roleMeta;
            return [2 /*return*/, res];
        });
    }); }, []);
    var runSavedAccountContinue = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var res, sdk, roleMeta, verifier;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    res = {
                        newSelect: false,
                        newSelectWhenFailedContinue: !disableAccountAutoSelectRole,
                        roleMeta: null,
                        roleInfo: null,
                        clearRoleMetaWhenVerifiedFailed: true,
                    };
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _a.sent();
                    roleMeta = getRoleMeta({ site: site });
                    if (!roleMeta)
                        return [2 /*return*/, res];
                    if (roleMeta.channel !== "account")
                        return [2 /*return*/, res];
                    if (disableAccount)
                        return [2 /*return*/, res];
                    if (disableAccountInheritRole)
                        return [2 /*return*/, res];
                    return [4 /*yield*/, sdk.Account.API.getToken()];
                case 2:
                    verifier = (_a.sent()) || "";
                    if (roleMeta.verifier === verifier) {
                        // const { token, roleInfo } = await fetchAccountRole()
                        // if (token === roleMeta.token) {
                        //     res.roleMeta = roleMeta
                        //     res.roleInfo = roleInfo
                        //     return res
                        // }
                        res.roleMeta = roleMeta;
                        return [2 /*return*/, res];
                    }
                    // 当verifier不匹配时，立马清除RoleMeta
                    clearRoleMeta({ site: site });
                    return [2 /*return*/, res];
            }
        });
    }); }, []);
    var runAccountRoleSetup = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var res, sdk, verifier, _a, token, roleInfo;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    res = {
                        newSelect: false,
                        newSelectWhenFailedContinue: !disableAccountAutoSelectRole,
                        roleMeta: null,
                        roleInfo: null,
                        clearRoleMetaWhenVerifiedFailed: true,
                    };
                    if (disableAccount)
                        return [2 /*return*/, res];
                    if (disableAccountAutoSelectRole)
                        return [2 /*return*/, res];
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _b.sent();
                    return [4 /*yield*/, sdk.Account.API.getToken()];
                case 2:
                    verifier = (_b.sent()) || "";
                    return [4 /*yield*/, fetchAccountRole()];
                case 3:
                    _a = _b.sent(), token = _a.token, roleInfo = _a.roleInfo;
                    if (!token) {
                        clearRoleMeta({ site: site });
                        onNoRole === null || onNoRole === void 0 ? void 0 : onNoRole({ auto: true });
                        // 如果在森空岛内，自动登录没有角色情况下，默认弹出角色选择页
                        if (isSKLand())
                            showRoleSelect();
                        return [2 /*return*/, res];
                    }
                    res.newSelect = true;
                    res.roleMeta = {
                        channel: "account",
                        verifier: verifier,
                        token: token,
                    };
                    res.roleInfo = roleInfo;
                    return [2 /*return*/, res];
            }
        });
    }); }, []);
    function checkWithThirdParty() {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, runChannelRecognizer(channelConfigList)
                        // 2. 判断是否有可继承的第三方渠道用户信息
                    ];
                    case 1:
                        res = _a.sent();
                        if (!!res.roleMeta) return [3 /*break*/, 3];
                        return [4 /*yield*/, runSavedChannelContinue()];
                    case 2:
                        res = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, res];
                }
            });
        });
    }
    function checkWithAccount() {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, runSavedAccountContinue()
                        // 2. 判断是否在未登录的场景下，自动使用平台账号登录
                    ];
                    case 1:
                        res = _a.sent();
                        if (!!res.roleMeta) return [3 /*break*/, 3];
                        return [4 /*yield*/, runAccountRoleSetup()];
                    case 2:
                        res = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, res];
                }
            });
        });
    }
    function verifyRoleWithServer(roleMeta) {
        return __awaiter(this, void 0, void 0, function () {
            var roleInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        roleInfo = null;
                        if (shouldGetRoleInClient)
                            return [2 /*return*/, null
                                // 先设置 roleMeta 到 store 中
                                // 原因：fetchRoleInfo 的实现可能使用 createRequest 出来的httpClient
                            ];
                        // 先设置 roleMeta 到 store 中
                        // 原因：fetchRoleInfo 的实现可能使用 createRequest 出来的httpClient
                        setRoleMeta(roleMeta, { site: site });
                        return [4 /*yield*/, fetchRoleInfo(roleMeta.token)
                            // 如果不能正常返回，表示角色会话不一致
                        ];
                    case 1:
                        // 携带当前的客户端token与服务器端会话校验
                        // 如果能正常返回用户信息，则表示会话一致
                        roleInfo = _a.sent();
                        // 如果不能正常返回，表示角色会话不一致
                        if (!roleInfo)
                            clearRoleMeta({ site: site });
                        return [2 /*return*/, roleInfo];
                }
            });
        });
    }
    function verifyCheckResult(res) {
        return __awaiter(this, void 0, void 0, function () {
            var newSelect, newSelectWhenFailedContinue, roleMeta, clientRole, roleInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSelect = res.newSelect, newSelectWhenFailedContinue = res.newSelectWhenFailedContinue, roleMeta = res.roleMeta, clientRole = res.roleInfo;
                        // 如果经过检测阶段，并不能获得到任何的roleMeta信息
                        // 表示并不从客户端侧得到任何有效角色
                        if (!roleMeta)
                            return [2 /*return*/, { roleInfo: null, roleMeta: null }];
                        roleInfo = clientRole;
                        if (!(newSelect && onSelectRole)) return [3 /*break*/, 2];
                        return [4 /*yield*/, onSelectRole(roleMeta.token)
                            // 如果不需要通过服务端会话获取角色信息，直接返回客户端账号结果
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // 如果不需要通过服务端会话获取角色信息，直接返回客户端账号结果
                        if (shouldGetRoleInClient)
                            return [2 /*return*/, { roleInfo: roleInfo, roleMeta: roleMeta }
                                // 通过获得到的RoleMeta尝试与服务器做一致性校验，并获取角色信息
                            ];
                        return [4 /*yield*/, verifyRoleWithServer(roleMeta)
                            // 服务器能正常返回角色信息，表示角色会话认证成功，一致性校验通过
                        ];
                    case 3:
                        // 通过获得到的RoleMeta尝试与服务器做一致性校验，并获取角色信息
                        roleInfo = _a.sent();
                        // 服务器能正常返回角色信息，表示角色会话认证成功，一致性校验通过
                        if (roleInfo)
                            return [2 /*return*/, { roleInfo: roleInfo, roleMeta: roleMeta }
                                // 如果需要继承一致性校验失败时，自动触发选角操作
                            ];
                        if (!(newSelectWhenFailedContinue && !newSelect && onSelectRole)) return [3 /*break*/, 6];
                        return [4 /*yield*/, onSelectRole(roleMeta.token)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, verifyRoleWithServer(roleMeta)];
                    case 5:
                        roleInfo = _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/, { roleInfo: roleInfo, roleMeta: roleMeta }];
                }
            });
        });
    }
    var settle = function (res) { return __awaiter(_this, void 0, void 0, function () {
        var clearRoleMetaWhenVerifiedFailed, _a, roleInfo, roleMeta;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    clearRoleMetaWhenVerifiedFailed = res.clearRoleMetaWhenVerifiedFailed;
                    return [4 /*yield*/, verifyCheckResult(res)
                        // 如果当前没有任何验证通过用户
                    ];
                case 1:
                    _a = _b.sent(), roleInfo = _a.roleInfo, roleMeta = _a.roleMeta;
                    // 如果当前没有任何验证通过用户
                    if (!roleInfo) {
                        if (clearRoleMetaWhenVerifiedFailed)
                            clearRoleMeta({ site: site });
                        return [2 /*return*/];
                    }
                    setRoleMeta(roleMeta);
                    dispatch({
                        role: roleInfo,
                        isAccount: roleMeta.channel === "account",
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    // 渠道账号只会触发一次
    useEffect(function () {
        channelInitiatingProcessRef.current = checkWithThirdParty()
            .then(settle)
            .catch(function (err) {
            onError ? onError(err.message, err) : console.error(err);
        })
            .finally(function () {
            channelInitiatingProcessRef.current = null;
            if (disableAccount) {
                dispatch({ loading: false, ready: true });
            }
        });
    }, []);
    // 平台账号等到AccountProvider第一次准备好之后开始触发且触发一次
    useEffect(function () {
        if (disableAccount || !accountReady)
            return;
        // 未初始化account流程时
        if (!accountInitiatedRef.current) {
            accountInitiatedRef.current = true;
            var run = function () {
                // 如果当前没有登录任何平台账号
                if (!accountInfo) {
                    dispatch({ loading: false, ready: true });
                    return;
                }
                checkWithAccount()
                    .then(settle)
                    .catch(function (err) {
                    var _a;
                    (_a = onError === null || onError === void 0 ? void 0 : onError(err.message, err)) !== null && _a !== void 0 ? _a : console.error(err);
                })
                    .finally(function () {
                    dispatch({ loading: false, ready: true });
                });
            };
            if (channelInitiatingProcessRef.current) {
                channelInitiatingProcessRef.current.then(run).catch(run);
            }
            else {
                run();
            }
        }
    }, [disableAccount, accountReady, accountInfo]);
    useOnAccountLogin(function () {
        if (disableAccount)
            return;
        dispatch({ loading: true });
        _onAccountChange({
            sdkReady: sdkReady,
            fetchAccountRole: fetchAccountRole,
            onError: onError,
            site: site,
            onSelectRole: onSelectRole,
            onNoRole: onNoRole,
            fetchRoleInfo: fetchRoleInfo,
            dispatch: dispatch,
        }).finally(function () { return dispatch({ loading: false }); });
    }, [
        disableAccount,
        sdkReady,
        fetchAccountRole,
        onError,
        site,
        onSelectRole,
        onNoRole,
        fetchRoleInfo,
        dispatch,
    ]);
    useOnAccountLogout(function () {
        if (disableAccount && !store.isAccount)
            return;
        clearRoleMeta({ site: site });
        dispatch({ role: null, isAccount: null });
    }, [disableAccount, store.isAccount]);
    return null;
}
function initChannelConfig(channels) {
    if (isSKLand())
        return [];
    return channels.reduce(function (prev, item) {
        if (prev.findIndex(function (i) { return i.channel === item.channel; }) >= 0) {
            console.warn("[@hg/one-account] Role provider received channel \"".concat(item.channel, "\" config more than once, config will be omitted except the very first one."));
        }
        if (item.custom) {
            prev.push(item);
        }
        else if (PresetChannelOptionMap[item.channel]) {
            prev.push(__assign({ option: item.option }, PresetChannelOptionMap[item.channel]));
        }
        return prev;
    }, []);
}
// 获取Account下的角色信息
function _fetchAccountRole(option) {
    return __awaiter(this, void 0, void 0, function () {
        var sdkReady, gameCode, shouldGetRoleInClient, disableAccountRoleSelect, token, roleInfo, sdk, u8Token, role, res, err_2, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sdkReady = option.sdkReady, gameCode = option.gameCode, shouldGetRoleInClient = option.shouldGetRoleInClient, disableAccountRoleSelect = option.disableAccountRoleSelect;
                    token = null;
                    roleInfo = null;
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _a.sent();
                    if (!disableAccountRoleSelect) return [3 /*break*/, 11];
                    if (!(sdk.SDK_TYPE === "HG")) return [3 /*break*/, 9];
                    return [4 /*yield*/, sdk.U8.API.authByAccount(gameCode)];
                case 2:
                    u8Token = _a.sent();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 7, , 8]);
                    if (!shouldGetRoleInClient) return [3 /*break*/, 5];
                    return [4 /*yield*/, sdk.U8.API.getRoleInfo(u8Token)];
                case 4:
                    role = _a.sent();
                    roleInfo = {
                        uid: role.uid,
                        channelMasterId: role.channelMasterId,
                        nickName: role.nickName,
                    };
                    _a.label = 5;
                case 5: return [4 /*yield*/, sdk.U8.API.grant(u8Token)];
                case 6:
                    res = _a.sent();
                    token = res.token;
                    return [3 /*break*/, 8];
                case 7:
                    err_2 = _a.sent();
                    if (sdk.Utils.isSDKError(err_2) && err_2.code === "NO_ROLE") {
                        // 当 U8 过程出现没有角色错误时
                        return [2 /*return*/, { token: token, roleInfo: roleInfo }];
                    }
                    throw err_2;
                case 8: return [3 /*break*/, 10];
                case 9:
                    console.warn("[disableAccountRoleSelect] not supported in GL_WEB_SDK.");
                    _a.label = 10;
                case 10: return [3 /*break*/, 13];
                case 11: return [4 /*yield*/, sdk.Role.API.getActiveRole(gameCode)];
                case 12:
                    res = _a.sent();
                    if (res) {
                        token = res.token;
                        roleInfo = {
                            uid: res.role.uid,
                            channelMasterId: res.role.channelMasterId,
                            nickName: res.role.nickName,
                        };
                    }
                    _a.label = 13;
                case 13: return [2 /*return*/, { token: token, roleInfo: roleInfo }];
            }
        });
    });
}
function _onAccountChange(option) {
    return __awaiter(this, void 0, void 0, function () {
        var sdkReady, fetchAccountRole, onError, site, onSelectRole, onNoRole, fetchRoleInfo, dispatch, sdk, verifier, token, clientRole, res, err_3, roleMeta, roleInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sdkReady = option.sdkReady, fetchAccountRole = option.fetchAccountRole, onError = option.onError, site = option.site, onSelectRole = option.onSelectRole, onNoRole = option.onNoRole, fetchRoleInfo = option.fetchRoleInfo, dispatch = option.dispatch;
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _a.sent();
                    return [4 /*yield*/, sdk.Account.API.getToken()];
                case 2:
                    verifier = (_a.sent()) || "";
                    token = null;
                    clientRole = null;
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, fetchAccountRole()];
                case 4:
                    res = _a.sent();
                    token = res.token;
                    clientRole = res.roleInfo;
                    return [3 /*break*/, 6];
                case 5:
                    err_3 = _a.sent();
                    onError === null || onError === void 0 ? void 0 : onError(sdk.Utils.isSDKError(err_3) ? err_3.message : "", err_3);
                    return [2 /*return*/];
                case 6:
                    if (!token) {
                        // 如果手动登录之后，账号没有角色，清除本地角色Meta
                        clearRoleMeta({ site: site });
                        dispatch({ role: null, isAccount: null });
                        return [2 /*return*/, onNoRole === null || onNoRole === void 0 ? void 0 : onNoRole({ auto: false })];
                    }
                    roleMeta = {
                        channel: "account",
                        verifier: verifier,
                        token: token,
                    };
                    if (!onSelectRole) return [3 /*break*/, 8];
                    return [4 /*yield*/, onSelectRole(token)];
                case 7:
                    _a.sent();
                    setRoleMeta(roleMeta, { site: site });
                    _a.label = 8;
                case 8:
                    if (!roleMeta) return [3 /*break*/, 12];
                    roleInfo = null;
                    if (!fetchRoleInfo) return [3 /*break*/, 10];
                    return [4 /*yield*/, fetchRoleInfo(roleMeta.token)];
                case 9:
                    roleInfo = _a.sent();
                    return [3 /*break*/, 11];
                case 10:
                    roleInfo = clientRole;
                    _a.label = 11;
                case 11:
                    setRoleMeta(roleMeta, { site: site });
                    if (roleInfo)
                        dispatch({ role: roleInfo, isAccount: true });
                    _a.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    });
}
